import { type StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import { css } from '@repo/pandacss/styled-system/css';
import { type CtaType } from '@repo/segment/Analytics/types';
import { AnalyticsType } from '@repo/segment/types';
import { type AuthorQuote } from '@repo/supergraph/roundup/base/authorQuote/types';
import { StructuredContentRenderer } from '../../../StructuredContentRenderer';

type Props = {
  bottomLine?: StructuredContentDocument;
  cta?: CtaType;
  ctaAnalytics?: AnalyticsType;
  authorQuote?: AuthorQuote;
  displayName?: string;
};

export const BottomLine = ({ bottomLine, cta, ctaAnalytics, authorQuote, displayName }: Props) => {
  const ctaData = cta && ctaAnalytics && { cta, ctaAnalytics };
  return (
    <div
      className={css({
        paddingInlineStart: { md: '4', base: '0' },
        paddingInlineEnd: { md: '4', base: '0' },
        paddingBottom: '2',
        maxWidth: '[705px]',
        '& p': {
          fontSize: '[13px]',
          lineHeight: 'normal',
          fontWeight: 'normal',
          marginBlockStart: '0',
          marginBlockEnd: '0',
          width: { md: '[calc(100% + 2rem)]', base: 'full' },
          maxWidth: { md: '[705px]', base: 'full' },
        },
        wordBreak: 'break-word',
      })}
    >
      <span className={css({ textStyle: 'textSmallBold' })}>Why We Like It</span>
      {/* This logic will be removed by https://nerdwallet.atlassian.net/browse/BNK-812 */}
      <StructuredContentRenderer
        doc={bottomLine}
        rendererProps={{ Link: { isWithinProductCardBottomLine: true, ctaData } }}
      />
      {authorQuote && displayName && (
        <p
          className={css({
            textStyle: 'textSmall',
            marginTop: '2',
          })}
        >
          <strong>
            How <a href={authorQuote.author.link}>{authorQuote.author.fullName}</a>,{' '}
            {authorQuote.author.jobTitle}, uses {displayName}:
          </strong>{' '}
          &ldquo;{authorQuote.quote}&rdquo;
        </p>
      )}
    </div>
  );
};
